export default __webpack_public_path__ + "fonts/poppins-latin-700-normal.c54a52658bf21b37083d.woff";